module.exports = __webpack_public_path__ + "static/media/header2.3b53f7d4.jpg";